import { QUOTATIONS } from "../_constants";

const clearQuotationsStore = (data) => {
    return {
        type: QUOTATIONS.CLEAR,
        data
    };
}


export const quotationsAction = {
    clearQuotationsStore,
}